import React, { useMemo } from 'react';
import { formatClubStats } from "../../../shared/utils";
import ClubLeaderCardFigure from "../ClubLeaderCardFigure";
import ClubLeaderCardBody from "../ClubLeaderCardBody";
import { useLeaderCard } from "../../utils";

function ClubLeaderData() {
  const { first } = useLeaderCard();

  return (
    <>
      <ClubLeaderCardFigure clubData={first} />
      <ClubLeaderCardBody first={first} />
    </>
  );
}

// eslint-disable-next-line no-func-assign
ClubLeaderData = React.memo(ClubLeaderData);

export default ClubLeaderData;
